import { render } from "./ItemSeparator.vue?vue&type=template&id=70219c6c&ts=true"
import script from "./ItemSeparator.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemSeparator.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/item/ItemSeparator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70219c6c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70219c6c', __exports__)) {
    api.reload('70219c6c', __exports__)
  }
  
  module.hot.accept("./ItemSeparator.vue?vue&type=template&id=70219c6c&ts=true", () => {
    api.rerender('70219c6c', render)
  })

}


export default __exports__